var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.10186,
    y: 0.45,
    width: 19.7957,
    height: 8.83913,
    stroke: "#233A80",
    strokeWidth: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14.6086,
    width: 1.21739,
    height: 28,
    transform: "rotate(90 28 14.6086)",
    fill: "#233A80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0001,
    cy: 15.2172,
    r: 1.82609,
    transform: "rotate(90 14.0001 15.2172)",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineHorizontal);
export default __webpack_public_path__ + "static/media/timelineHorizontal.088ee08d01fa96f9f9448be474153751.svg";
export { ForwardRef as ReactComponent };